import axios from "axios";

const agreementsUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/agreements/backoffice`;
const agreementsBaseUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/agreements`;

function urlManager(url = null, product = null) {
  if (url !== null){
    let urlManager = url
    if (product !== null) {
      urlManager = `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services${urlManager.split('/services').pop()}`
    }
    return urlManager
  }
}

export const getAgreements = async (token, displayError = () => {}, params) => {
  let url = `${agreementsUrl}${params?.query || params?.page ? "?" : ""}${
    params?.query && params?.query !== "" ? `search=` + params?.query : ``
  }${params?.query && params?.page ? `&` : ""}${
    params?.page ? `page=` + params?.page : ``
  }`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getAgreements error: " + error.message);
    });
};

export const editAgreement = async (token, data, displayError = () => {}) => {
  return await axios
    .put(`${urlManager(agreementsBaseUrl, 'mediline')}/${data?.id}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("editAgreement error: " + error.message);
    });
};

export const activateAgreement = async (token, data, displayError = () => {}) => {
  return await axios
    .post(
      `${urlManager(agreementsUrl, 'mediline')}/${data?.id}`,
      { ...data, activated: true },
      { headers: { authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("activateAgreement error: " + error.message);
    });
};

export const disableAgreement = async (
  token,
  id,
  reason,
  displayError = () => {}
) => {
  return await axios
    .delete(`${urlManager(agreementsUrl,'mediline')}/${id}/${reason}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("disableAgreement error: " + error.message);
    });
};

export const createAgreement = async (token, data, displayError = () => {}) => {
  return await axios
    .post(`${urlManager(agreementsBaseUrl, 'mediline')}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("createAgreement error: " + error.message);
    });
};

export const getAllAgreements = async (token, displayError = () => {}, params) => {
  let url = `${agreementsBaseUrl}`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getAllAgreements error: " + error.message);
    });
};
export const getLastAgreementNumber = async (token, displayError = () => {}, params) => {
  let url = `${agreementsBaseUrl}/last-agreement-number`;
  return await axios
    .get(url, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (token) displayError("getAllAgreements error: " + error.message);
    });
};